import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { BoxV2 as Box } from 'portal-commons';
import CampaignsByCsps from './CampaignsByCsps';
import CampaignsByCspsDeclined from './CampaignsByCspsDeclined';
import { ListingTab } from '../components';
import { TRACKING_REJECTED_CAMPAIGNS } from '@/constants';
import {
  CSP_CAMPAIGNS_PATH,
  DECLINED_CSP_CAMPAIGNS_PATH,
} from '@/constants/paths';

export type TenDlcListingTabKey =
  | 'shared-csp-campaigns'
  | 'declined-csp-campaigns';
export const TenDlcListingTabConfig = {
  items: [
    { key: 'shared-csp-campaigns', label: 'Shared' },
    { key: 'declined-csp-campaigns', label: 'Declined' },
  ],
  routes: {
    'shared-csp-campaigns': {
      pathname: CSP_CAMPAIGNS_PATH,
      search: '?status=ACTIVE&provisional=false',
    },
    'declined-csp-campaigns': {
      pathname: DECLINED_CSP_CAMPAIGNS_PATH,
      search: '?status=ACTIVE&provisional=false',
    },
  },
};

const CampaignsByCspsContainer: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const isDeclined = location.pathname === DECLINED_CSP_CAMPAIGNS_PATH;

  const handleTabChange = (tab: string) => {
    const tabLocation =
      TenDlcListingTabConfig.routes[tab as TenDlcListingTabKey];
    if (tabLocation) {
      const { pathname, search } = tabLocation;
      history.push({
        pathname,
        search: search || '',
      });
    }
  };

  return (
    <>
      {TRACKING_REJECTED_CAMPAIGNS && (
        <Box
          sx={{ mt: -15, mb: 20, width: '100%' }}
          data-testid="campaignsByCspsListingTab"
        >
          <ListingTab
            items={TenDlcListingTabConfig.items}
            activeTab={
              isDeclined ? 'declined-csp-campaigns' : 'shared-csp-campaigns'
            }
            onTabChange={handleTabChange}
          />
        </Box>
      )}
      {isDeclined ? <CampaignsByCspsDeclined /> : <CampaignsByCsps />}
    </>
  );
};

export default CampaignsByCspsContainer;
